<script>
  import { OverlayScrollbarsComponent } from 'overlayscrollbars-vue'
  import 'overlayscrollbars/overlayscrollbars.css'

  export default {
    name: 'OverlayScrollbars',

    components: {
      OverlayScrollbarsComponent
    },

    props: {
      element: {
        type: String,
        default: 'div'
      }
    }
  }
</script>

<template>
  <OverlayScrollbarsComponent
    :element="element"
    defer
    :options="{ scrollbars: { autoHide: 'leave' } }"
  >
    <slot />
  </OverlayScrollbarsComponent>
</template>